import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitLead = (data) => api.post("/leads", data).then((r) => r.data);
export const fetchLeads = (token) =>
  api.get("/leads", { headers: { "X-Admin-Token": token } }).then((r) => r.data);
export const fetchLeadStats = (token) =>
  api.get("/leads/stats", { headers: { "X-Admin-Token": token } }).then((r) => r.data);
